import {useMemo} from 'react';
import {UnitsSystem} from '@/Pages/Common/LocalUnits/types';
import {
  ProductionCostKpis,
  KpiValue,
  ProductionCostBusScheduleKpi
} from '@/Pages/ProductionCost/store/types';
import {useLocalUnitsContext} from '@/Pages/Common/LocalUnits';
import {ReadOnlyInputProps} from '@/components/ReadOnlyInput/ReadOnlyInput.types';

export interface ReadOnlyKpiInputConfig {
  label: string | React.ReactElement;
  formatValue: (kpi: KpiValue, localUnits: UnitsSystem) => string;
  id: string;
  order: number;
}

export const useReadOnlyKpiInputConfigBuilder = (
  kpis: ProductionCostKpis | ProductionCostBusScheduleKpi | null,
  kpiConfig: Record<string, ReadOnlyKpiInputConfig>
): Array<ReadOnlyInputProps & {order: number}> => {
  const {localUnits} = useLocalUnitsContext();

  return useMemo(() => {
    if (!kpis) return [];

    const fields: Array<ReadOnlyInputProps & {order: number}> = [];

    for (const key in kpiConfig) {
      const config = kpiConfig[key];
      const kpiValue = kpis[key as keyof ProductionCostKpis];
      if (kpiValue) {
        fields.push({
          label: config.label,
          value: config.formatValue(kpiValue, localUnits),
          id: config.id,
          order: config.order
        });
      }
    }

    return fields.sort((a, b) => a.order - b.order);
  }, [kpis, kpiConfig, localUnits]);
};
